/**
 * 平台 API 抽象
 * - 业务层通过本模块访问平台差异 API，不直接使用 #ifdef
 */

export const PLATFORM = (() => {
  // #ifdef H5
  return 'h5' as const
  // #endif
  // #ifdef MP-WEIXIN
  return 'mp-weixin' as const
  // #endif
  // #ifdef APP-PLUS
  return 'app' as const
  // #endif
  // eslint-disable-next-line no-unreachable
  return 'unknown' as const
})()

export const IS_H5 = PLATFORM === 'h5'
export const IS_MP_WEIXIN = PLATFORM === 'mp-weixin'
export const IS_APP = PLATFORM === 'app'

export function hideToast(): void {
  uni.hideToast()
}

export function showToast(title: string, icon: UniApp.ShowToastOptions['icon'] = 'none'): void {
  // 先清掉残留 toast，避免 H5 跨页粘住（WEB-A01）
  uni.hideToast()
  uni.showToast({ title, icon, duration: 2000 })
}

export function showLoading(title = '加载中...'): void {
  uni.showLoading({ title, mask: true })
}

export function hideLoading(): void {
  uni.hideLoading()
}

export function showModal(content: string, title = '提示'): Promise<boolean> {
  return new Promise((resolve) => {
    uni.showModal({
      title,
      content,
      success: (res) => resolve(res.confirm),
      fail: () => resolve(false),
    })
  })
}

export function openExternalUrl(url: string): void {
  if (!url) {
    showToast('暂无原文链接')
    return
  }
  // 仅放行 http(s)：拦 javascript:/data: 等可执行协议，防上游污染 link 触发 XSS（High#7）
  if (!/^https?:\/\//i.test(url)) {
    showToast('链接无效')
    return
  }
  // #ifdef H5
  window.open(url, '_blank', 'noopener,noreferrer')
  // #endif
  // #ifndef H5
  uni.setClipboardData({
    data: url,
    success: () => showToast('链接已复制，请在浏览器打开'),
  })
  // #endif
}
